import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ToastService } from 'src/app/services/toast.service';

import { MemberPaths } from 'src/app/constants/routes';
import { ToastType } from 'src/app/constants/toast-type';
import { SessionService } from '../services/storage/session.service';

@Injectable()
export class ACAGuard implements CanActivate {

    constructor(
        private sessionService: SessionService,
        private toastService: ToastService,
        private router: Router,
    ) {
    }

    public canActivate(): Observable<boolean> {
        if (!this.sessionService.session?.member.useACAModule) {
            this.toastService.buildToastMessage(ToastType.warning, 'Access Denied', 'ACA Module not activated for this company');
            this.router.navigateByUrl(MemberPaths.Benefits);
            return of(false);
        }

        return of(true);
    }
}